import { Controller } from "@hotwired/stimulus"
import FieldHandler from "../src/field_handler"

export default class extends Controller {
  static targets = ["dropdown", "input", "bubblesContainer", "bubbleTemplate", "component"]
  static values = {
    name: String,
    searchUrl: String,
    frameId: String,
    fieldName: String,
    form: Boolean,
    old: { // wsparcie dla single_select (value), bulk_action (name_id)
      type: Object,
      default: { send: false, value: "", name_id: "" },
    },
  }

  searchTimeout = null
  count = 0
  connect() {
    console.log("intum select connect")
    this.frame = document.getElementById(this.frameIdValue)
    this.multiple = this.element.dataset.multiple === "true"

    this.fieldHandler = new FieldHandler(this.element, this.fieldNameValue)

    this.open = false
    // otwieranie dropdownu po kliknieciu w input
    this.inputTarget.addEventListener("click", this.showDropdown.bind(this))
    this.inputTarget.addEventListener("keydown", event => {
      if (event.key === "Enter") {
        event.preventDefault()
      }
    })
    // zamykanie dropdownu po kliknieciu poza nim
    document.addEventListener("click", this.hideDropdown.bind(this))

    this.frameLoaded = false
    // akcje po zaladowaniu frame'a
    this.frame.addEventListener("turbo:frame-load", () => {
      this.frameLoaded = true
      this.toggleSelection()
      this.hideSpinner()
    })
  }

  search() {
    clearTimeout(this.searchTimeout)

    this.searchTimeout = setTimeout(() => {
      if (this.frame) {
        const fieldIds = Array.from(this.fieldHandler.fields).map(field => field.value).join(",")
        this.showDropdown()
        this.showSpinner()
        if (this.searchUrlValue.includes("?")) {
          this.frame.src = `${this.searchUrlValue}&q=${encodeURIComponent(this.inputTarget.value)}&frame=${this.frameIdValue}&ids=${fieldIds}`
        } else {
          this.frame.src = `${this.searchUrlValue}?q=${encodeURIComponent(this.inputTarget.value)}&frame=${this.frameIdValue}&ids=${fieldIds}`
        }
      } else {
        console.error(`Frame with ID ${this.frameIdValue} not found`)
      }
    }, 1000) // 1s
  }

  findElementByDataAttribute(container, attribute, value) {
    const attributeName = attribute.replace("data-", "")
    return Array.from(container.querySelectorAll(`div[${attribute}]`))
      .find(el => el.dataset[attributeName] === value)
  }

  toggleResult(event) {
    const value = this.getFieldValue(event)
    const searchItem = this.findElementByDataAttribute(this.frame, "data-value", value)
    console.log("searchItem:", searchItem)
    console.log("Toggling:", searchItem, value)

    this.select(searchItem, value)
  }

  toggleSelection() {
    console.log("toggleSelection")
    this.fieldHandler.fields.forEach(field => {
      const result = this.findElementByDataAttribute(this.frame, "data-value", field.value)
      if (result) this.toggleSearchFieldDetails(result)
    })
  }

  toggleBubble(event) {
    // if this is a single select field, remove all other fields
    if (!this.multiple) {
      // mimick the click event on all bubbles to remove them
      const event = new Event("click")
      console.log("Removing all bubbles")
      this.bubblesContainerTarget.querySelectorAll("div[data-bubble]").forEach(bubble => {
        bubble.querySelector("button").dispatchEvent(event)
      })
    }

    const id = this.getFieldValue(event)
    const bubble = this.findElementByDataAttribute(this.bubblesContainerTarget, "data-bubble", id)
    console.log("toggling bubble:", bubble, id)

    if (bubble) this.removeBubble(event)
    else this.addBubble(event)
  }

  addBubble(event) {
    event.preventDefault()
    const id = event.currentTarget.dataset.value
    const name = event.currentTarget.querySelector("#name").querySelector("span").textContent
    const bubble = this.bubbleTemplateTarget.content.cloneNode(true)

    bubble.querySelector("#bubble").dataset.bubble = id
    bubble.querySelector("#name").textContent = name
    this.bubblesContainerTarget.prepend(bubble)
    const clearButton = this.bubblesContainerTarget.querySelector("#clearAllButton")
    if (clearButton) { clearButton.classList.remove("hidden") }
    this.clearInput()
  }

  removeBubble(event) {
    event.preventDefault()
    console.log("Removing bubble")
    // zarowno we frame istnieje div[data-value] jak i w bubble istnieje div[data-bubble], maja one korespondujace ze soba wartosci
    const value = this.getFieldValue(event)
    const field = this.findElementByDataAttribute(this.bubblesContainerTarget, "data-bubble", value)

    field.remove()
  }

  select(field, value) {
    console.log("Selecting:", field, value)
    this.fieldHandler.handleFieldChange(value)
    if (this.hasComponentTarget) { this.componentTarget.dispatchEvent(new Event("change", { bubbles: true })) }
    // ukrywamy elementy z searcha tylko gdy frame jest juz załadowany
    if (this.frameLoaded) { this.toggleSearchFieldDetails(field) }

    // chcemy submitowac form tylko wtedy gdy jest to single select i jest tylko jeden element wyszukany
    // odpalamy toggleResult w _bubble.html.erb i zeby uniknac submitowania formularza, gdy sa jeszcze dwie wartosci w hidden fields
    if (this.formValue && this.fieldHandler.fields.length === 1) {
      const form = this.element.closest("form")
      if (form) {
        this.addOldValue() // opcjonalne dodanie pierwotnej wartości do formularza
        form.requestSubmit()
      }
    }
  }

  clearBubbles(_event) {
    const event1 = new Event("click")
    console.log("Removing all bubbles")
    this.bubblesContainerTarget.querySelectorAll("div[data-bubble]").forEach(bubble => {
      bubble.querySelector("button").dispatchEvent(event1)
    })

    this.bubblesContainerTarget.querySelector("#clearAllButton").classList.add("hidden")
  }

  toggleSearchFieldDetails(field) {
    // czasami nie ma już w selectcie tego co próbujemy togglować
    // na przykład po wyszukaniu kogoś innego, obecnie wybrana osoba nie jest już na liście
    if (!field) { return }

    this.toggleCrossIcon(field)
    this.toggleTickIcon(field)
  }

  disconnect() {
    document.removeEventListener("click", this.hideDropdown.bind(this))
  }

  toggleTickIcon(target) { target.querySelector(".tick-icon").classList.toggle("hidden") }
  toggleCrossIcon(target) { target.querySelector(".cross-icon").classList.toggle("hidden") }
  hideSpinner() { this.element.querySelector("#spinner").classList.add("hidden") }
  showSpinner() { this.element.querySelector("#spinner").classList.remove("hidden") }
  showDropdown() {
    if (this.open) { return }
    console.log("showDropdown", this.open)
    this.dropdownTarget.classList.remove("hidden")
    this.open = true
  }

  toggleDropdown() {
    console.log("toggleDropdown", this.open)
    this.dropdownTarget.classList.toggle("hidden")
    this.open = !this.open
    if (this.open) { this.inputTarget.focus() }
  }

  clearInput() { this.inputTarget.value = "" }
  hideDropdown(event) {
    if (!this.open) { return }

    // sprawdzamy czy event.target jest inputem lub buttonem, ale zahaczamy tez o elementy w srodku buttona, np divy
    const isInputOrButton = (element, depth = 5) => {
      if (!element || depth === 0) return false
      if (element.tagName === "INPUT" || element.tagName === "BUTTON") return true
      return isInputOrButton(element.parentElement, depth - 1)
    }

    if (!this.element.contains(event.target) || !isInputOrButton(event.target)) {
      console.log("hiding dropdown", this.open)
      this.dropdownTarget.classList.add("hidden")
      this.open = false
    }
  }

  getFieldValue(event) {
    const closestDiv = event.currentTarget.closest("div[data-value]") || event.currentTarget.closest("div[data-bubble]")
    return closestDiv.dataset.value || closestDiv.dataset.bubble
  }

  // wsparcie wysyłania pierwotnej wartości pola / pól dla single_select, bulk_action
  addOldValue() {
    if (this.oldValue["send"] === false) { return }

    if (this.nameValue === "single_select") {
      this.fieldHandler.addHiddenField(`old_${this.fieldNameValue}`, this.oldValue["value"])
    }

    if (this.nameValue === "bulk_action") {
      const fieldName = this.fieldNameValue.endsWith("[]") ? this.fieldNameValue.slice(0, -2) : this.fieldNameValue

      // dla poprawnego działania bulk action z opcją old, pozyskujemy z widoku dokumenty stare wartości
      document.querySelectorAll(`div#bulk_action_old[data-name-id="${this.oldValue["name_id"]}"]`).forEach(el => {
        const id = el.dataset.id
        const oldValue = el.dataset.value
        this.fieldHandler.addHiddenField(`old_${fieldName}[${id}]`, oldValue)
      })
    }
  }
}
